import { SubscriptionPlans } from '@/constants/subscriptionModels';

export const useSubscriptionPlans = () => {
  return SubscriptionPlans;
};
